import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { getNotices } from '../../../../api/notice/queries/getNotices';
import { INotice } from '../../../../interfaces/Notice.interfaces';
import { compareDesc, parseISO } from 'date-fns';

export const useGetNoticesQuery = () => {
  return useQuery<INotice[], AxiosError>(['notices'], getNotices, {
    select: (data) => {
      return [...data].sort((a, b) => compareDesc(parseISO(a.createdAt), parseISO(b.createdAt)));
    },
  });
};
